import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const MicOffIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="m2 2 20 20" />
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
    <path d="M19 10v2a7 7 0 0 1-11.5 5.3" />
    <path d="M12 19v3" />
  </Icon>
)
